import { ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/**
 * "Só a equipe vê" (F-161a 7b): an area nobody outside the team can open
 * (private with nobody in "Who has access"). The flag comes from the API
 * (`adminOnly`, staff only); this only draws it.
 *
 * - `badge`: the icon on the menu row, with the short text on hover.
 * - `banner`: the strip on top of the space or the section.
 * - `inline`: the same warning inside "Who has access" while configuring.
 */
export function AdminOnlyNotice({ variant, className }: { variant: 'badge' | 'banner' | 'inline'; className?: string }) {
  const { t } = useTranslation('common')

  if (variant === 'badge') {
    const label = t('access.adminOnly.badge')
    return (
      <span title={label} aria-label={label} role="img" className={cn('flex-shrink-0 text-amber-600', className)} data-admin-only-badge>
        <ShieldCheck className="h-3.5 w-3.5" />
      </span>
    )
  }

  return (
    <div
      role="note"
      className={cn(
        'flex items-start gap-2 text-amber-800',
        variant === 'banner'
          ? 'border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm sm:px-6'
          : 'rounded-md bg-amber-50 px-2.5 py-2 text-xs',
        className
      )}
      data-admin-only-notice={variant}
    >
      <ShieldCheck className={cn('mt-0.5 flex-shrink-0', variant === 'banner' ? 'h-4 w-4' : 'h-3.5 w-3.5')} />
      <span>{t('access.adminOnly.banner')}</span>
    </div>
  )
}
